import { render, staticRenderFns } from "./pcB.vue?vue&type=template&id=3507612e&scoped=true"
import script from "./pcB.vue?vue&type=script&lang=js"
export * from "./pcB.vue?vue&type=script&lang=js"
import style0 from "./pcB.vue?vue&type=style&index=0&id=3507612e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3507612e",
  null
  
)

export default component.exports